import Modal from '../Utils/Modal';
import '../../styles/salesmanModal.scss';
import SummaryModalLoader from '../Loader/SummaryModalLoader';
import { connect } from 'react-redux';
import DesktopSummaryModalContent from './Content/DesktopSummaryModalContent.jsx';
import MobileSummaryModalContent from './Content/MobileSummaryModalContent.jsx';
import { isMobile } from 'react-device-detect';

const SummaryModal = (props) => {
  const currencies = [];
  const grossValueSummary = {};
  const factoreeCommissionSummary = {};
  const receiverCommissionSummary = {};
  const partnerCommissionSummary = {};

  const handleSum = (summary, amount, currency) => {
    // eslint-disable-next-line no-prototype-builtins
    if (summary.hasOwnProperty(currency)) {
      summary[currency] += parseInt(amount);
    } else {
      summary[currency] = parseInt(amount);
    }

    if (currency && !currencies.includes(currency)) {
      currencies.push(currency);
    }
  };

  const displayValueForCurrency = (summary, currency) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!summary.hasOwnProperty(currency)) {
      return 0;
    }

    return new Intl.NumberFormat('pl-PL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(summary[currency] / 100);
  };

  props.data.map((row) => {
    handleSum(grossValueSummary, row.amount, row.currency);
    handleSum(factoreeCommissionSummary, row.fffAmount, row.fffCurrency);
    handleSum(receiverCommissionSummary, row.ffoAmount, row.ffoCurrency);
    handleSum(partnerCommissionSummary, row.partnerCommissionAmount, row.partnerCommissionCurrency);
  });

  return (
    <Modal
      {...props}
      style={{
        content: {
          minWidth: '300px',
          maxWidth: '1200px',
        },
      }}
      data={{}}
    >
      <div className='modal-container' style={{ minWidth: '250px' }}>
        {!props.isSummaryLoading &&
          (isMobile ? (
            <MobileSummaryModalContent
              currencies={currencies}
              roles={props.roles}
              displayValueForCurrency={displayValueForCurrency}
              grossValueSummary={grossValueSummary}
              factoreeCommissionSummary={factoreeCommissionSummary}
              receiverCommissionSummary={receiverCommissionSummary}
              partnerCommissionSummary={partnerCommissionSummary}
            />
          ) : (
            <DesktopSummaryModalContent
              currencies={currencies}
              roles={props.roles}
              displayValueForCurrency={displayValueForCurrency}
              grossValueSummary={grossValueSummary}
              factoreeCommissionSummary={factoreeCommissionSummary}
              receiverCommissionSummary={receiverCommissionSummary}
              partnerCommissionSummary={partnerCommissionSummary}
            />
          ))}
        {props.isSummaryLoading && <SummaryModalLoader />}
      </div>
    </Modal>
  );
};

export default connect((state) => state.authReducer)(SummaryModal);
